(function () {
    'use strict';

    angular
        .module('salesflare.components.topEarningAccounts', [])
        .component('sfTopEarningAccounts', {
            templateUrl: 'app-ajs/components/dashboards/predefinedReports/topEarningAccounts/topEarningAccounts.html',
            controller,
            controllerAs: 'vm',
            bindings: {
                data: '<'
            }
        });

    function controller($state, $mdMedia, model, config) {

        const vm = this;

        vm.model = model;

        ////////////////

        vm.$onChanges = function (changes) {

            if (!changes || !changes.data || !changes.data.currentValue) {
                return;
            }

            // Show empty state
            if (vm.data.top_earning_accounts.length === 0) {
                vm.data.no_data = true;
                vm.data.top_earning_accounts = [
                    { name: 'Google', picture: 'https://d2ojpxxtu63wzl.cloudfront.net/static/b560062037213e5dd697ef328cecdd3c_9c5671e1cd34db87e3d8bbfb230555c37b4572c9769d40c5eb04b6233b0e2a57', total: 232000 },
                    { name: 'Facebook', picture: config.logoApi + 'e3ef2bf121699043dbe2466d56576aba--8719d1461f33832036b0ee2b4464b99f', total: 10000 },
                    { name: 'X', picture: 'images/socials/x-logo.png', total: 78000 },
                    { name: 'Youtube', picture: 'https://d2ojpxxtu63wzl.cloudfront.net/static/68bdc551de55a3b98e469a567ea4d073_80ce7ef516349893a46c3137e287c3bbc01382b4048c3a26bb56e0cc41d8d2ba', total: 63000 },
                    { name: 'Tesla', picture: 'https://d2ojpxxtu63wzl.cloudfront.net/static/482876a60cfd09da211a221bd05420f6_540f6b9b45f97f3247782c51bf742b041b8530f4b16cd6817a74b16ed4ae2ecd', total: 54000 },
                    { name: 'Linkedin', picture: config.logoApi + 'a615d94c77f5e811120114d0ded81dce--6f0068d8fc95606f29db0549e6c8c996', total: 17000 },
                    { name: 'Quora', picture: 'https://d2ojpxxtu63wzl.cloudfront.net/static/c46060cff6fe0b61e81688605d28dacf_e47df089748b513b0a3ab1106187ffaa74c45bfe101ca5c948f09f17c9f8d28a', total: 9000 }
                ];
            }
        };

        vm.goToAccount = function (account) {

            if ($mdMedia('gt-sm')) {
                return $state.go('accounts.account.feed', { id: account.id, name: account.name });
            }
            else {
                return $state.go('accounts.account.info', { id: account.id, name: account.name });
            }
        };
    }
})();
